'use strict';

var cookie = require("cookie");;

module.exports = function(name) {
    var cookies = cookie.parse(document.cookie);
    var result = cookies[name];

    if (result === undefined) return null;

    return result;
};
